import "./App.css";
import Landing from "./components/landing";

function App() {
  return (
    <div className="App">
      <Landing />
    </div>
  );
}

export default App;
